module.exports = __webpack_public_path__ + "static/img/index_02_02.3867c18.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/index_02_02.png
// module id = f3RY
// module chunks = 1